import React from "react";
import logo from "../../assets/white_trans_logo.png";
import { Link, NavLink, useLocation } from "react-router-dom";
import MobileHeader from "./MobileHeader";
import { PlatformContext } from "../Platform/PlatformContext";
import navLinks from "./NavLinks";
import { UserContext } from "../UserContext";

const Header: React.FC = () => {
  const location = useLocation();
  const context = React.useContext(PlatformContext);
  const isDesktop = context?.isDesktop;
  const user = React.useContext(UserContext).user;
  const isAdmin = user?.role === "ADMIN";
  const isDashboard = location.pathname.startsWith("/dashboard");
  if (isDashboard && isDesktop) {
    return null;
  }
  if (!isDesktop) {
    return <MobileHeader isDashboard={isDashboard} />;
  }
  return (
    <header className="border-b border-b-gray-500 h-28 z-50 top-0 sticky flex items-center justify-between pl-10 pr-10 pt-5 pb-5 bg-header-secondary text-white">
      <div className="flex ">
        <Link to="/">
          <img src={logo} alt="Logo" className="h-[60px]" />
        </Link>
      </div>

      <nav className="flex">
        <ul className="flex justify-center items-center gap-x-6">
          {navLinks(false, false, isAdmin).map((e: any, index: any) => (
            <li key={index}>
              <NavLink
                className="px-3 py-2 rounded-xl hover:bg-white/10 text-lg"
                to={e.link}
              >
                {e.titel}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
